import { styled } from '@material-ui/core';

export const FormControlContainer = styled('div')({
	display: 'flex',
	flexDirection: 'column',
	padding: 0,
});

export const InputError = styled('p')({
	fontFamily: 'var(--font-family-regular)',
	fontSize: 'var(--text-caption-size)',
	lineHeight: 'var(--leading-normal)',
	color: 'var(--color-error)',
	margin: 0,
});

export const TextCheckbox = styled('input')({
	'outline': 'none',
	'borderRadius': 'var(--radius-sm)',
	'height': 18,
	'width': 18,
	'cursor': 'pointer',
	'accentColor': 'var(--color-brand-primary)',
	'transition': 'box-shadow var(--transition-fast)',
	'&:focus-visible': {
		boxShadow: '0 0 0 3px color-mix(in srgb, var(--color-brand-primary) 30%, transparent)',
	},
	'&:disabled': {
		cursor: 'not-allowed',
		opacity: 0.5,
	},
});
